/**
 * <Badge />
 *
 * Small pill for tags like "DEALER", "NEW", "SOLD", "FEATURED". Variants
 * lean on the Red/Black/White palette exclusively -- no green/blue etc.
 */
import * as React from "react";
import { cn } from "../../lib/cn";

type BadgeVariant = "brand" | "solid" | "outline" | "soft" | "muted";
type BadgeSize = "sm" | "md";

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: BadgeVariant;
  size?: BadgeSize;
}

const variants: Record<BadgeVariant, string> = {
  brand: "bg-brand text-white",
  solid: "bg-ink text-white",
  outline: "bg-white text-ink border border-surface-borderStrong",
  soft: "bg-brand-soft text-brand-ink",
  muted: "bg-surface-sunken text-ink-muted",
};

const sizes: Record<BadgeSize, string> = {
  sm: "text-[11px] px-2 py-0.5 tracking-wider",
  md: "text-xs px-2.5 py-1 tracking-wider",
};

export function Badge({
  variant = "brand",
  size = "md",
  className,
  children,
  ...rest
}: BadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center font-semibold uppercase rounded-full",
        variants[variant],
        sizes[size],
        className,
      )}
      {...rest}
    >
      {children}
    </span>
  );
}
